import React from 'react'
import { ScoreBreakdownItemProps } from './ScoreRadarModal.types'
import {
  BreakdownItem,
  BreakdownItemHeader,
  BreakdownItemTitle,
  BreakdownItemSubtitle,
  BreakdownItemScore,
  ProgressBarContainer,
  ProgressBarFill,
  BreakdownItemDescription,
} from './ScoreRadarModal.styles'

const getScoreColorInternal = (score: number): string => {
  if (score >= 70) return '#10B981'
  if (score >= 40) return '#F59E0B'
  return '#3B82F6'
}

export const ScoreBreakdownItem: React.FC<ScoreBreakdownItemProps> = ({
  radarLabel,
  displayLabel,
  description,
  value,
  animationDelay,
  animate,
}) => {
  const color = getScoreColorInternal(value)

  return (
    <BreakdownItem>
      <BreakdownItemHeader>
        <BreakdownItemTitle>
          {radarLabel}
          <BreakdownItemSubtitle>({displayLabel})</BreakdownItemSubtitle>
        </BreakdownItemTitle>
        <BreakdownItemScore $color={color}>
          {Math.round(value)}/100
        </BreakdownItemScore>
      </BreakdownItemHeader>
      <ProgressBarContainer>
        <ProgressBarFill
          $percentage={value}
          $color={color}
          $animate={animate}
          $animationDelay={animationDelay}
        />
      </ProgressBarContainer>
      <BreakdownItemDescription>{description}</BreakdownItemDescription>
    </BreakdownItem>
  )
}
